(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('payday-header-countdown')) {
  customElements.define('payday-header-countdown', class extends HTMLElement {
    connectedCallback() {
      const deadline = Date.parse(this.dataset.deadline);
      const clock = this.querySelector('.payday-header-clock');
      const update = () => {
        const remaining = Math.ceil((deadline - Date.now()) / 1000);
        if (!Number.isFinite(remaining) || remaining <= 0) {
          this.textContent = this.dataset.after;
          clearInterval(this.interval);
          this.interval = undefined;
          return;
        }
        if (clock) clock.textContent = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(value => String(value).padStart(2, '0')).join(':');
      };
      update();
      if (deadline > Date.now()) this.interval = setInterval(update, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
